import { initializeApp } from "firebase/app";
import { 
  getFirestore, collection, addDoc, updateDoc, deleteDoc, doc, 
  query, onSnapshot, where, writeBatch, getDocs, setDoc, getDoc 
} from "firebase/firestore";

// 1. ADIM: "setPersistence" ve "browserSessionPersistence" komutlarını buraya ekledik
import { 
  getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut, sendPasswordResetEmail,
  setPersistence, browserSessionPersistence, sendEmailVerification
} from "firebase/auth";

// --- AYARLAR ---
const firebaseConfig = {
  apiKey: "AIzaSyBMQdJTmaxEcVHLOKpAXKr6WvlmcuIR7nk",
  authDomain: "rehber360-e0808.firebaseapp.com",
  projectId: "rehber360-e0808",
  storageBucket: "rehber360-e0808.firebasestorage.app",
  messagingSenderId: "366691489652",
  appId: "1:366691489652:web:11a4c0b913a4cceb0e7e21"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app); // Kimlik doğrulama servisi

// 2. ADIM: YENİ GÜVENLİK KİLİDİ!
// Firebase'e diyoruz ki: "Sonsuz hafızayı unut, sekme kapandığı an şifreyi sil ve çıkış yap!"
setPersistence(auth, browserSessionPersistence)
  .catch((error) => console.error("Güvenlik (Persistence) Ayarı Hatası:", error));

// --- KULLANICI İŞLEMLERİ (AUTH) ---

export const registerUser = async (email, password, fullName, schoolName) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    // YENİ: KAYIT OLDUĞU ANDA DOĞRULAMA MAİLİNİ ATEŞLE!
    // actionCodeSettings ile linki yine bizim siteye yönlendiriyoruz ki araya botlar girmesin
    const actionCodeSettings = {
      url: `${window.location.origin}/dogrulama`, // Yeni yapacağımız doğrulama sayfası
      handleCodeInApp: true,
    };
    await sendEmailVerification(user, actionCodeSettings);

    // Kodu burada üretiyoruz (Sadece 4 haneli rakam)
    const randomCode = Math.floor(1000 + Math.random() * 9000);
    const refCode = String(randomCode);

    // SADECE userProfile OBJESİNİ ŞUNUNLA DEĞİŞTİR:
    const userProfile = {
      uid: user.uid,
      email: user.email,
      fullName: fullName,
      schoolName: schoolName,
      refCode: refCode,
      role: 'specialist',
      isPremium: false,
      createdAt: new Date().toISOString(),
      credits: {
        holland_inventory: 20,
        sinav_kaygisi: 20,
        rosenberg_benlik_saygisi: 20,
        devamsizlik_nedenleri: 20,
        vak_inventory: 20,
        basarisizlik_nedenleri: 20,
        yasam_pencerem: 20,
        asrs_form: 20,
        snap_iv_form: 20,
        dass_21: 20,
        internet_bagimliligi: 20,
        coklu_zeka_envanteri: 20,
        bana_kendini_anlat: 20,
        sosyometri_testi: 20,
        mesleki_egilim_belirleme: 20,
        kariyer_pusulasi: 20,
        mesleki_degerler_envanteri: 20,
        ogrenci_bilgi_formu: 20,
        kisa_psikolojik_saglamlik: 20,
        liebowitz_sosyal_kaygi: 20
      }
    };

    // Veritabanına yazıyoruz
    await setDoc(doc(db, "users", user.uid), userProfile);

    return userProfile; 

  } catch (error) {
    console.error("Kayıt Hatası:", error);
    throw error;
  }
};

// 2. GİRİŞ YAP (Login)
export const loginUser = async (email, password) => {
  try {
    await setPersistence(auth, browserSessionPersistence);
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user; // Kodun okunurluğu için değişkene aldık
    
    // YENİ GÜVENLİK DUVARI: E-posta doğrulanmış mı?
    if (!user.emailVerified) {
      // SİHİRLİ DOKUNUŞ: Çıkış yapmadan hemen önce yeni bir link fırlatıyoruz
      await sendEmailVerification(user, {
        url: `${window.location.origin}/dogrulama`,
        handleCodeInApp: true,
      });

      // Eğer doğrulanmamışsa Firebase'den çıkış yaptır ve hata fırlat
      await signOut(auth);
      
      // Kullanıcıyı bilgilendiren daha net bir mesaj
      throw new Error("E-posta adresiniz henüz doğrulanmamış. Size yeni bir doğrulama bağlantısı gönderdik, lütfen gelen kutunuzu (ve spam klasörünü) kontrol edin.");
    }

    return user;
  } catch (error) {
    console.error("Giriş Hatası:", error);
    throw error; 
  }
};

// 3. ÇIKIŞ YAP
export const logoutUser = async () => {
  await signOut(auth);
};

// 4. KULLANICI DETAYLARINI GETİR (Kredi sorgulama için)
export const getUserProfile = async (uid) => {
  const docRef = doc(db, "users", uid);
  const docSnap = await getDoc(docRef);
  
  if (docSnap.exists()) {
    let userData = docSnap.data();
    
    // YENİ: OTOMATİK PREMIUM SÜRE TAKİP VE DÜŞÜRME MOTORU
    if (userData.isPremium && userData.premiumEndDate) {
      const endDate = new Date(userData.premiumEndDate);
      const now = new Date();
      
      // Eğer şu anki tarih, bitiş tarihini geçmişse...
      if (now > endDate) {
        // 1. Ücretsiz (Free) paketin standart kredilerini hazırla
        const resetCredits = {
          holland_inventory: 5, sinav_kaygisi: 5, rosenberg_benlik_saygisi: 5,
          devamsizlik_nedenleri: 5, vak_inventory: 5, basarisizlik_nedenleri: 5,
          yasam_pencerem: 5, asrs_form: 5, snap_iv_form: 5, dass_21: 5,
          internet_bagimliligi: 5, coklu_zeka_envanteri: 5, bana_kendini_anlat: 5,
          sosyometri_testi: 1
        };

        // 2. Veritabanında (Firestore) kullanıcıyı sessizce Free plana düşür
        await updateDoc(docRef, {
          isPremium: false,
          credits: resetCredits
        });
        
        // 3. React tarafına (Ekrana) kullanıcının yetkisinin alındığını bildir
        userData.isPremium = false;
        userData.credits = resetCredits;
      }
    }
    
    return userData;
  } else {
    return null;
  }
};

// 5. KREDİ DÜŞME (Analiz Yapınca Çalışacak)
export const useCredit = async (uid, testId) => {
  const userRef = doc(db, "users", uid);
  const userSnap = await getDoc(userRef);
  
  if (userSnap.exists()) {
    const userData = userSnap.data();
    
    // Eğer Premium ise kredi düşme, direkt onayla
    if (userData.isPremium) return true;

    // Free üye ise kredisini kontrol et
    let currentCredit = userData.credits?.[testId];
    
    // SİHİRLİ DOKUNUŞ: Eğer kullanıcının o teste ait hiç kredi kaydı yoksa (eski üye veya yeni test)
    if (currentCredit === undefined) {
      currentCredit = (testId === 'sosyometri_testi' || testId?.includes('sosyometri')) ? 1 : 5;
    }
    
    if (currentCredit > 0) {
      // Krediyi 1 azalt
      await updateDoc(userRef, {
        [`credits.${testId}`]: currentCredit - 1
      });
      return true; // İşlem başarılı
    } else {
      return false; // Kredi bitti!
    }
  }
  return false;
};

// --- STANDART VERİ İŞLEMLERİ ---

export const saveToCloud = async (collectionName, data) => {
  try {
    const docRef = await addDoc(collection(db, collectionName), data);
    return docRef.id;
  } catch (e) {
    console.error("Hata:", e);
    return null;
  }
};

export const updateInCloud = async (collectionName, docId, data) => {
  try {
    const ref = doc(db, collectionName, docId);
    await updateDoc(ref, data);
    return true;
  } catch (e) {
    console.error("Güncelleme Hatası:", e);
    return false;
  }
};

export const deleteFromCloud = async (collectionName, docId) => {
  try {
    const docRef = doc(db, collectionName, docId);
    await deleteDoc(docRef);
    return true;
  } catch (error) {
    console.error("Silme hatası:", error);
    throw error;
  }
};

export const deleteAllFromCloud = async (collectionName) => {
  try {
    const q = query(collection(db, collectionName));
    const snapshot = await getDocs(q);
    const batch = writeBatch(db);
    snapshot.docs.forEach((doc) => batch.delete(doc.ref));
    await batch.commit();
    return true;
  } catch (error) {
    console.error("Toplu silme hatası:", error);
    return false;
  }
};

// 6. ŞİFRE SIFIRLAMA LİNKİ GÖNDERME (ÖZEL DOMAİN VE BOT KORUMALI)
export const resetUserPassword = async (email) => {
  try {
    // SİHİRLİ DOKUNUŞ: Linki kendi domainimize (rehber360.net) yönlendiriyoruz!
   const actionCodeSettings = {
      // SİHİR BURADA: window.location.origin o an localhosttaysan localhost'u, 
      // canlı sitedeysen rehber360.net'i otomatik alır!
      url: `${window.location.origin}/sifre-yenile`,
      handleCodeInApp: true, 
    };

    // İkinci parametre olarak actionCodeSettings'i ekledik
    await sendPasswordResetEmail(auth, email, actionCodeSettings);
    return true;
  } catch (error) {
    console.error("Şifre sıfırlama hatası:", error);
    throw error;
  }
};

export const listenToData = (collectionName, callback) => {
  const q = query(collection(db, collectionName));
  return onSnapshot(q, (querySnapshot) => {
    const data = [];
    querySnapshot.forEach((doc) => {
      data.push({ ...doc.data(), firebaseId: doc.id }); 
    });
    callback(data);
  });
};

// 7. VİTRİN (LANDING PAGE) İÇİN ONAYLI YORUMLARI ÇEKME MOTORU
export const getPublicTestimonials = async () => {
  try {
    const q = query(
      collection(db, "feedbacks"),
      where("category", "==", "testimonial"),
      where("consentForPublic", "==", true)
    );
    const snapshot = await getDocs(q);
    const testimonials = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    // Yeniden eskiye sıralayalım ki en yeni yorumlar vitrinde görünsün
    return testimonials.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  } catch (error) {
    console.error("Vitrin yorumlarını çekerken hata:", error);
    return [];
  }
};